import { cloneOnsiteTemplate } from '../../utils/queries';
import { CloneTemplateButton } from './CloneTemplateButton';
import { ArchiveTemplateButton } from './ArchiveTemplateButton';
import { useTemplatesListState } from '../../context/UseTemplatesListContext';
import { getOnsiteQueryKeysToInvalidate } from '../../utils/getQueryKeysToInvalidate';

export interface OnsiteOptionsProps {
  setShowModal(show: boolean): void;
}

export const OnsiteOptions = ({ setShowModal }: OnsiteOptionsProps) => {
  const { selectedTemplate } = useTemplatesListState();

  return (
    <>
      <CloneTemplateButton
        setShowModal={setShowModal}
        cloneFunction={cloneOnsiteTemplate}
        getQueryKeysToInvalidate={() => getOnsiteQueryKeysToInvalidate(selectedTemplate)}
        selectedTemplate={selectedTemplate}
      />
      <ArchiveTemplateButton
        selectedTemplate={selectedTemplate}
        getQueryKeysToInvalidate={() => getOnsiteQueryKeysToInvalidate(selectedTemplate)}
      />
    </>
  );
};
